import { Button, Modal } from "flowbite-react"
import React, { Dispatch, ReactNode, SetStateAction } from "react"

import { DownloadIcon } from "@assets/icons"
import Successful from "@icons/Successful"
import { GetOrderDetailsResponseType } from "@mono/essentials/types/OrderTypes"

interface OrderConfirmationModalProps {
  orderData: GetOrderDetailsResponseType
  show: boolean
  setShow?: Dispatch<SetStateAction<boolean>>
  handleModalClose?: () => void
}
const OrderConfirmModal = ({
  orderData,
  show,
  setShow,
  handleModalClose,
}: OrderConfirmationModalProps) => {
  return (
    <Modal
      className={"widget-theme-wrapper"}
      show
      onClose={() => {
        setShow?.(false)
        handleModalClose?.()
      }}
      size={"lg"}
    >
      <Modal.Header className={"border-b-0 pb-0 !bg-lightBg"} />
      <Modal.Body className={"px-6 pt-2 pb-8"}>
        <div className={"flex justify-center text-center"}>
          <Successful className={"h-14 w-14"} />
        </div>
        <div>
          <div
            className={"text20Semibold py-3 text-center tracking-wide"}
          >{`${orderData?.total_paid ? "Payment successful!" : "The order was placed successfully!"}`}</div>
          <div className={"text16Medium py-1.5 text-center tracking-wide text-neutral-600"}>
            {`${orderData?.total_paid ? "Your order has been placed." : ""}`}Your order number is{" "}
            <span className={"text16Semibold text-neutral-900"}>{orderData?.order_number}.</span>
          </div>
          <div className={"text14Regular text-center tracking-wide text-neutral-600"}>
            Please check your inbox for the confirmation email. If you don't receive the email,
            please check your spam/junk folder.
          </div>
        </div>
      </Modal.Body>
      {/* <Modal.Footer className="justify-center pt-2 pb-3">
        <Button color="ghost">
          Download Invoice
          <DownloadIcon className="ml-2 h-5 w-5" />{' '}
        </Button>
      </Modal.Footer> */}
    </Modal>
  )
}
export default OrderConfirmModal
